import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        formPageNumber: 0,
        isEditMode: false,
        showPageDialog: true,
        masterData: {},
        submissionId: null,
        isAgreed: false,
        isAgreedConfirm: false,
        country: 'hk',
        isProdEnv: false,
        fromData: {
            proposer_detail: {
                name: null,
                id: null,
                nationality: null,
                phone_country_code: null,
                phone: null,
                email: null,
                address1: null,
                address2: null,
                address3: null,
                address4: null,
                address5: null,
                country: null,
                business_nature: null,
                mortgagees: null,
            },
            yacht_detail: {
                yacht_hull_type: null,
                yacht_power_type: null,
                name: null,
                year_built: null,
                licensing_office: null,
                license_no: null,
                builders: null,
                model: null,
                material_hull: null,
                material_hull_other: null,
                material_mast: null,
                material_mast_other: null,
                length: null,
                beam: null,
                gross_tonnage: null,
                make_engine: null,
                engine_serialno: null,
                horse_power: null,
                max_speed: null,
                engine_type: null,
                engine_number: null,
                fuel_type: null,
                surface_drive: null,
            },
            yacht_usage: {
                what_used: [],
                who_operates: null,
                years_sailing_experience: null,
                cruising_range: null,
                cruising_range_desc: null,
                mooring_type: null,
                mooring_type_desc: null,
                where_yacht_moored: null,
                details_moored_security: null,
                is_yacht_fitted_auto_fire_flight: null,
                is_surveyed_by_surveyor: null,
                attachment_yacht_survey: [],
            },
            insured_values: {
                currency: null,
                insured_value_hull: null,
                insured_value_dinghy: null,
                insured_value_special_equipment: null,
                insured_value_personal_effect: null,
                purchase_date_hull: null,
                purchase_date_dinghy: null,
                purchase_date_special_equipment: null,
                purchase_price_hull: null,
                purchase_price_dinghy: null,
                purchase_price_personal_effect: null,
                purchase_price_special_equipment: null,
            },
            policy_detail: {
                proposed_insurance_inception_date: null,
                type_of_insurance: null,
                limit_third_party_liability: null,
                is_additional_cover_required: "N",
                is_cover_sails: "N",
                cover_sails_replacement_value: null,
                is_cover_sports: "N",
                cover_sports_type: null,
                limit_liability: null,
            },
            claim_record: {
                is_exist_claim: null,
                is_exist_claim_desc: null,
                is_insurance_declined: "N",
                declined_reason: null,
                cancel_reason: null,
                attachment: [],
            },
        },
        accessData: {
            url: null,
            ip: null,
            countrycode: 'HK',
            uniqueid_session: "_" + Math.random().toString(36).substr(2, 9),
            uniqueid_user: "",
        },
        timeNow: null
    },

    getters: {
        countryList: function(state) {
            return state.masterData["country"];
        },
        hullMaterialArray: function(state) {
            return state.masterData["hull_material"];
        },
        mystMaterialArray: function(state) {
            return state.masterData["myst_material"];
        },
        engineType: function(state) {
            return state.masterData["engine_type"];
        },
        engineNumber: function(state) {
            return state.masterData["engine_number"];
        },
        fuelType: function(state) {
            return state.masterData["fuel_type"];
        },
        surfaceDrive: function(state) {
            return state.masterData["radio_button"];
        },
        yatchOperatorList: function(state) {
            return state.masterData["yacht_operator"];
        },
        cruisingRangeList: function(state) {
            return state.masterData["cruising_range"];
        },
        mooringTypeList: function(state) {
            return state.masterData["mooring_type"];
        },
        currencyList: function(state) {
            return state.masterData["currency"];
        },
        liablilityRequiredList: function(state) {
            return state.masterData["liability_required"];
        },
        liablilityLimitList: function(state) {
            return state.masterData["liability_limit"];
        },
        coverRequiredList: function(state) {
            return state.masterData["radio_button"];
        },
        getMasterList: function(state) {
            return state.masterData;
        },
        getFormDetails: function(state) {
            return state.fromData;
        },
        getPersonalDetails: function(state) {
            return state.fromData.proposer_detail;
        },
        getYatchDetails: function(state) {
            return state.fromData.yacht_detail;
        },
        getYatchUsage: function(state) {
            return state.fromData.yacht_usage;
        },
        getInsuredValue: function(state) {
            return state.fromData.insured_values;
        },
        getPolicyDetails: function(state) {
            return state.fromData.policy_detail;
        },
        getClaimRecord: function(state) {
            return state.fromData.claim_record;
        },
    },

    actions: {
        saveMasterData(context, data) {
            context.commit("setMasterData", data);
        },
        saveSubmissionId(context, data) {
            context.commit("setSubmissionId", data);
        },
        saveIpAddress(context, data) {
            context.commit("setIpAddress", data);
        },
    },

    mutations: {
        setMasterData(state, data) {
            this.state.masterData = data;
        },
        savePersonalDetails(state, payload) {
            return (state.fromData.proposer_detail = payload);
        },
        saveYatchDetails(state, payload) {
            return (state.fromData.yacht_detail = payload);
        },
        saveYatchUsage(state, payload) {
            return (state.fromData.yacht_usage = payload);
        },
        saveInsuredValue(state, payload) {
            return (state.fromData.insured_values = payload);
        },
        savePolicyDetails(state, payload) {
            return (state.fromData.policy_detail = payload);
        },
        saveClaimRecord(state, payload) {
            return (state.fromData.claim_record = payload);
        },
        setSubmissionId(state, payload) {
            return (state.submissionId = payload);
        },
        setIpAddress(state, payload) {
            const ip = payload.substring(payload.search("ip=") + 3, payload.search("ts=")).trim();
            return (state.accessData.ip = ip);
        },
    },
});

export default store
